import { Input } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";

export interface EmailFieldProps extends TellescopeFormFieldBaseProps<"email"> {}

export const EmailField = ({ title, value, onChange, className, error, onBlur, touched }: EmailFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <Input
        type="email"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        className={cn(className, showError && "border-destructive")}
        aria-invalid={showError}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
